import {cssTheme} from '@logistics-frontend/blocks'
import {css} from '@logistics-frontend/blocks/theme/css'
import {spacing} from '@logistics-frontend/blocks/theme/theme'

export const classes = {
  container: css`
    background-color: ${cssTheme.default.day.backgroundMinor};
    border-radius: ${cssTheme.spacingUnits.m};
    padding-inline: ${cssTheme.spacingUnits.m};
  `,
  title: css`
    padding-block-start: ${cssTheme.spacingUnits.xl};
    padding-block-end: ${spacing(1.5)};
  `,
  item: css`
    min-height: 48px;

    &:not(:last-child) {
      border-bottom: 1px solid ${cssTheme.default.day.line};
    }
  `,
  label: css`
    padding-inline-end: ${cssTheme.spacingUnits.m};
  `,
}
